import { useEffect, useState } from "react";
import {
  Box,
  CircularProgress,
  Grid,
  makeStyles,
  Paper,
} from "@material-ui/core";
import RecursiveTreeView from "../../../../components/TreeView/RecursiveTreeView";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    height: "100%",
  },
  formArea: {
    color: theme.palette.text.secondary,
    maxHeight: "43vh",
    minHeight: "43vh",
    overflow: "auto",
    padding: theme.spacing(2),
    textAlign: "left",
  },
}));

export default function Hierarchy(props) {
  const { treeView } = props;
  const classes = useStyles();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (treeView?.complete) {
      setLoading(false);
    }
  }, [treeView]);

  return (
    <Box className={classes.root}>
      <h4 style={{ textAlign: "left" }}>Hierarchy Tree</h4>
      <Grid container direction="row" spacing={1}>
        <Grid item xs={12}>
          <Paper className={classes.formArea} elevation={0}>
            {!loading ? (
              <RecursiveTreeView data={treeView} />
            ) : (
              <CircularProgress />
            )}
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}
